import type { BlueprintRowComponent } from '@/grove-blueprints/generated-types'

type RowAlignment = NonNullable<
  NonNullable<BlueprintRowComponent['props']>['alignment']
>

const ROW_ALIGNMENT_CLASS: Record<RowAlignment, string> = {
  top: 'items-start',
  center: 'items-center',
  bottom: 'items-end',
  firstTextBaseline: 'items-baseline',
  lastTextBaseline: 'items-baseline',
}

export function resolveRowAlignment(
  alignment: RowAlignment | undefined,
): string {
  if (alignment === undefined) {
    return ''
  }

  return ROW_ALIGNMENT_CLASS[alignment]
}
